import { FC, ReactElement, useEffect, useState } from 'react';
import {
  StyledBrokenArrowDownIcon,
  StyledBrokenArrowUpIcon,
  StyledContent,
  StyledPercentage,
} from './PreviousPeriodComparison.styles';
import { useTranslation } from 'react-i18next';
import { STUDY_INSIGHTS_TRANSLATION } from '@/modules/study-insights/constants';
import { PreviousPeriodComparisonProps } from './PreviousPeriodComparison.types';
import { DateRangeOptionId } from '../../organisms';

export const PreviousPeriodComparison: FC<PreviousPeriodComparisonProps> = ({
  arrowColor,
  percentage,
  period,
  testId,
}) => {
  const { t } = useTranslation(STUDY_INSIGHTS_TRANSLATION);
  const [icon, setIcon] = useState<ReactElement>();
  const [percentChangeDisplay, setPercentChangeDisplay] = useState<string>('');

  useEffect(() => {
    if (percentage === undefined) {
      return;
    }

    if (percentage !== null) {
      setPercentChangeDisplay(percentage > 0 ? `+${percentage}` : percentage.toString());
    }

    setIcon(
      percentage === null || percentage >= 0 ? (
        <StyledBrokenArrowUpIcon css={{ color: arrowColor }} />
      ) : (
        <StyledBrokenArrowDownIcon css={{ color: arrowColor }} />
      ),
    );
  }, [percentage]);

  const getPeriodTextByDateRange = (period: DateRangeOptionId): string => {
    return t(`previous_period.${period}`);
  };

  return (
    <StyledContent>
      {icon}
      <StyledPercentage data-testid={`${testId}-percentage`}>
        {percentage !== null
          ? t('previous_period_change', {
            percentChange: percentChangeDisplay,
            period: getPeriodTextByDateRange(period),
          })
          : t('previous_period_change_no_value', {
            period: getPeriodTextByDateRange(period),
          })}
      </StyledPercentage>
    </StyledContent>
  );
};

export default PreviousPeriodComparison;
